export const UPLOAD_PROFILE_PHOTO = 'upload_profile_photo',
             UPLOAD_PROFILE_PHOTO_SUCCESS = 'upload_profile_photo_success',
             UPLOAD_PROFILE_PHOTO_FAIL = 'upload_profile_photo_fail', 
             UPLOAD_FILE = 'upload_file',
             UPLOAD_FILE_SUCCESS = 'upload_file_success',
             UPLOAD_FILE_FAIL = 'upload_file_fail';